import { Fragment, useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import FormTerritory, { TerritoryForm } from 'system/geographic/components/territory/form';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import { CommonTerritoryCrumbs } from '../constants';
import { HttpResponse } from 'shell/models/http-response';
import { Territory } from 'shell/models/territory';
import { toast } from 'react-toastify';

const TerritoryEditPage = (): React.ReactElement => {
  const { put: updateTerritory } = useHttpFetch(`${__MUNICIPALITY_API_URL__}/geo/territorio`);

  const params = useParams();

  const {
    get: getTerritory,
    data,
    error,
    loading,
  } = useHttpFetch<HttpResponse<Territory>>(
    `${__MUNICIPALITY_API_URL__}/geo/territorio/${params.id}`
  );

  useEffect(() => {
    getTerritory();
  }, []);

  const territory: TerritoryForm = useMemo(() => {
    const territoryPayload = data?.payload;
    if (!territoryPayload || !!error) {
      return {};
    }
    return {
      code: territoryPayload.key.codice,
      exonym: territoryPayload.esonimo,
      endonym: territoryPayload.endonimo,
      state: territoryPayload.codiceStato,
      electoralAgreement: territoryPayload.flagIntesa === 'S',
      continent: territoryPayload.codiceContinente,
    };
  }, [data, error]);

  const navigate = useNavigate();

  const onSubmit = useCallback(
    (formValues: TerritoryForm | undefined) => {
      updateTerritory(`/${formValues?.code}`, {
        endonimo: formValues?.endonym,
        esonimo: formValues?.exonym,
        flagIntesa: formValues?.electoralAgreement ? 'S' : 'N',
        codiceStato: formValues?.state,
        codiceContinente: formValues?.continent,
        key: {
          codice: formValues?.code,
        },
      }).then(() => {
        toast.success('Operazione eseguita con successo');
        navigate('/sistema/geografiche/estero/territorio');
      });
    },
    [updateTerritory, navigate]
  );

  return (
    <Fragment>
      <Breadcrumbs items={[...CommonTerritoryCrumbs, { name: 'Modifica Territorio' }]} />
      {loading || error || !data ? undefined : (
        <FormTerritory
          title="Modifica Territorio"
          onOk={onSubmit}
          initialValues={territory}
          isEdit
          onCancel={() => {
            navigate('/sistema/geografiche/estero/territorio');
          }}
        />
      )}
    </Fragment>
  );
};

TerritoryEditPage.displayName = 'Territory edit page component';

export default TerritoryEditPage;
